/**
 * Luli For Babies — sincroniza blocos custom com a variante selecionada.
 *
 * O Horizon não re-renderiza a seção inteira ao trocar de variante: o
 * variant-picker busca o HTML novo e dispara ThemeEvents.variantUpdate com ele
 * em detail.data.html, e cada componente se atualiza sozinho (ver product-price.js).
 *
 * Qualquer bloco Luli que dependa da variante (badges de estoque, utilidades por
 * tamanho, etc.) envolve seu conteúdo em <luli-variant-sync data-sync-id="{{ block.id }}">
 * e este elemento troca o conteúdo pelo do HTML novo.
 */
import { ThemeEvents } from '@theme/events';

class LuliVariantSync extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  update = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    // Ignora atualizações vindas de outro produto (ex.: card na mesma página)
    const productId = this.dataset.productId;
    if (productId && event.target instanceof HTMLElement) {
      const sourceProductId = event.target.dataset.productId;
      if (sourceProductId && sourceProductId !== productId && !event.detail.data.newProduct) return;
    }

    const fresh = html.querySelector(`luli-variant-sync[data-sync-id="${this.dataset.syncId}"]`);
    if (!fresh) return;

    this.innerHTML = fresh.innerHTML;
  };
}

if (!customElements.get('luli-variant-sync')) {
  customElements.define('luli-variant-sync', LuliVariantSync);
}
